import { render, staticRenderFns } from "./LomakenappiTekstiJaIkoni.vue?vue&type=template&id=b7d7dfe4&"
import script from "./LomakenappiTekstiJaIkoni.vue?vue&type=script&lang=js&"
export * from "./LomakenappiTekstiJaIkoni.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b7d7dfe4')) {
      api.createRecord('b7d7dfe4', component.options)
    } else {
      api.reload('b7d7dfe4', component.options)
    }
    module.hot.accept("./LomakenappiTekstiJaIkoni.vue?vue&type=template&id=b7d7dfe4&", function () {
      api.rerender('b7d7dfe4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LomakenappiTekstiJaIkoni.vue"
export default component.exports